export const splitCsvIds = value => {
    if (value == null || value === '') return []
    return String(value)
        .split(/[,;]/)
        .map(s => Number(s.trim()))
        .filter(n => !Number.isNaN(n) && n > 0)
}

export const splitCsvStrings = value => {
    if (value == null || value === '') return []
    return String(value)
        .split(/[,;]/)
        .map(s => s.trim())
        .filter(Boolean)
}

export const getCustomerRowId = customer =>
    customer?.unique_id ?? customer?.UniqueId ?? null

export const getCustomerRowLabel = customer =>
    customer?.customer_name ?? customer?.DisplayText ?? ''

export const buildCustomerDisplayText = (customerIds = [], allCustomers = []) => {
    return (customerIds || [])
        .map(id =>
            allCustomers.find(c => getCustomerRowId(c) === id),
        )
        .map(getCustomerRowLabel)
        .filter(Boolean)
        .join(',')
}

export const parseGroupToForm = group => {
    if (!group?.GroupId) {
        return {
            groupId: null,
            groupName: '',
            autoEmail: true,
            onHold: false,
            templateIds: [],
            customerIds: [],
            userIds: [],
            otherEmails: [],
        }
    }

    const templateField =
        group.TemplateList ?? group.TemplateIds ?? group.TemplateId ?? ''

    return {
        groupId: group.GroupId,
        groupName: group.GroupName || '',
        autoEmail: group.AutoEmail === true || group.AutoEmail === 1,
        onHold: group.OnHold === true || group.OnHold === 1,
        templateIds: splitCsvIds(templateField),
        customerIds: splitCsvIds(group.CustomerList),
        userIds: splitCsvIds(group.UserList),
        otherEmails: splitCsvStrings(group.OtherEmails),
    }
}

export const buildRecipientPreview = (
    form,
    allUsers = [],
    allCustomers = [],
    allTemplates = [],
) => {
    const users = (form.userIds || [])
        .map(id => allUsers.find(u => u.unique_id === id))
        .filter(u => u && u.Email)

    const externals = (form.otherEmails || []).flatMap(s =>
        splitCsvStrings(s),
    )

    const customers = (form.customerIds || [])
        .map(id =>
            allCustomers.find(c => getCustomerRowId(c) === id),
        )
        .filter(Boolean)

    const templates = (form.templateIds || [])
        .map(id => allTemplates.find(t => t.Id === id))
        .filter(Boolean)

    return {
        users,
        externals,
        customers,
        templates,
        total: users.length + externals.length,
    }
}

export const countTemplates = item => {
    const field = item?.TemplateList ?? item?.TemplateIds ?? ''
    return splitCsvIds(field).length
}

export const countRecipients = item => {
    const users = splitCsvIds(item?.UserList).length
    const externals = splitCsvStrings(item?.OtherEmails).length
    if (users === 0 && externals > 0) return `${externals} ext only`
    return users + externals
}

export const getInitials = name => {
    if (!name) return '?'
    const parts = name.trim().split(/\s+/)
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
